import { FaWhatsapp } from 'react-icons/fa'
import { MdEmail, MdPhone, MdLocationOn, MdAccessTime } from 'react-icons/md'
import Button from '../ui/Button'
import { useSite } from '../../context/SiteContext'

const PHONE    = '07775000'
const WA_NUMBER= '20107775000'
const EMAIL    = 'info@farafeero.com'

// ─── Default contact info ──────────────────────────────────────────────────────
const DEFAULT_ROWS = [
  { Icon: MdPhone,       label: 'Phone',         value: PHONE,                href: `tel:${PHONE}`               },
  { Icon: FaWhatsapp,    label: 'WhatsApp',       value: 'Chat with us',       href: `https://wa.me/${WA_NUMBER}` },
  { Icon: MdEmail,       label: 'Email',          value: EMAIL,                href: `mailto:${EMAIL}`            },
  { Icon: MdLocationOn,  label: 'Location',       value: 'Cairo, Egypt',       href: null                         },
  { Icon: MdAccessTime,  label: 'Working Hours',  value: 'Daily: 9 AM – 10 PM',href: null                         },
]

// ─── Component ─────────────────────────────────────────────────────────────────
export default function ContactInfo() {
  const { siteOptions } = useSite()
  const c = siteOptions?.contact || {}

  const rows = c.phone
    ? [
        { Icon: MdPhone,      label: 'Phone',        value: c.phone,           href: `tel:${c.phone}` },
        c.whatsapp && { Icon: FaWhatsapp,  label: 'WhatsApp',    value: 'Chat with us',  href: `https://wa.me/${c.whatsapp.replace(/\D/g,'')}` },
        c.email    && { Icon: MdEmail,     label: 'Email',       value: c.email,         href: `mailto:${c.email}` },
        c.location && { Icon: MdLocationOn,label: 'Location',    value: c.location,      href: null },
        c.working_hours && { Icon: MdAccessTime, label: 'Working Hours', value: c.working_hours, href: null },
      ].filter(Boolean)
    : DEFAULT_ROWS

  const waNum = c.whatsapp?.replace(/\D/g,'') || WA_NUMBER
  const phone = c.phone || PHONE

  return (
    <div
      className="rounded-3xl p-8 md:p-10 text-white h-full flex flex-col"
      style={{ background: 'linear-gradient(135deg, #FF6BB5 0%, #7C3AFF 100%)' }}
    >
      {/* Header */}
      <div className="mb-8">
        <p className="font-body text-xs font-bold tracking-widest uppercase text-white/70 mb-2">
          Contact Us
        </p>
        <h2 className="font-display text-3xl text-white mb-3">
          We'd Love to Hear From You
        </h2>
        <p className="font-body text-white/80 text-sm leading-relaxed">
          Ready to book or have questions? Reach out — we reply fast.
        </p>
      </div>

      {/* Info rows */}
      <ul className="space-y-5 flex-1">
        {rows.map(({ Icon, label, value, href }) => (
          <li key={label} className="flex items-start gap-4">
            <div className="w-10 h-10 rounded-2xl bg-white/20 flex items-center justify-center shrink-0">
              <Icon size={18} />
            </div>
            <div>
              <p className="text-white/60 text-xs font-body mb-0.5">{label}</p>
              {href ? (
                <a
                  href={href}
                  target={href.startsWith('http') ? '_blank' : undefined}
                  rel={href.startsWith('http') ? 'noreferrer' : undefined}
                  className="font-body font-semibold text-sm text-white hover:text-secondary transition-colors"
                >
                  {value}
                </a>
              ) : (
                <p className="font-body font-semibold text-sm text-white">{value}</p>
              )}
            </div>
          </li>
        ))}
      </ul>

      {/* Balloon divider */}
      <div className="flex items-center gap-3 my-8">
        <div className="h-px bg-white/20 flex-1" />
        <span className="text-white/40 text-sm select-none" aria-hidden>🎈 🎀 🎈</span>
        <div className="h-px bg-white/20 flex-1" />
      </div>

      {/* CTA buttons */}
      <div className="flex flex-col gap-3">
        <Button
          href={`tel:${phone}`}
          variant="outline-white"
          className="w-full justify-center"
        >
          📞 Call Now: {phone}
        </Button>
        <Button
          href={`https://wa.me/${waNum}`}
          variant="whatsapp"
          icon={<FaWhatsapp size={18} />}
          className="w-full justify-center"
        >
          WhatsApp Us
        </Button>
      </div>
    </div>
  )
}
